module.exports = __webpack_public_path__ + "static/media/2009New.374458cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2009New.jpg
// module id = 1398
// module chunks = 2